package com.dotdrives.model

/** Dashboard-sized metadata and complete server aggregates, without donor history or design assets. */
data class FormsDashboardSnapshot(
    val forms: List<GivingForm> = emptyList(),
    /** Null means hidden or no completed gifts; a non-null map includes confirmed zero forms. */
    val stats: Map<String, FormStats>? = null,
    /** Null when no completed gifts are visible in the last 30 days. */
    val orgStats: FormOrgStats? = null,
    /** Distinct givers with active subscriptions, or null when none are visible. */
    val activePartnersCount: Int? = null,
    val stripeConnected: Boolean = false,
    val targets: List<Target> = emptyList(),
    val paymentReadiness: FormPaymentReadiness? = null,
)
